import React, { useContext, useCallback, useState, useEffect, useMemo } from 'react';
import MultiStep from './step/react-multistep';

import { AppContext, defaultSiteName } from '../../../AppContext';
import { MyFileUploader } from '../../MyFileUploader'
import { ArrowCircleDown, ArrowCircleUp, QuestionAnswer } from "@mui/icons-material";
import useLocalStorage from "use-local-storage";
import moment from "moment";

import {
    getDataDB,
    saveDataDB,
    modifyDataModel,
    modifyTextAI,
    countWords,
    isDescriptionField,
    isImageField,
    emailBankingApplicationForm,
    sendEmail,
    handleFontAwesomeRedirect
} from "../../../api";


const prevStyle = {};
const nextStyle = {};

const getTopNavStyles = (indx, length) => {
    let styles = []
    for (let i = 0; i < length; i++) {
        if (i < indx) {
            styles.push('done')
        } else if (i === indx) {
            styles.push('doing')
        } else {
            styles.push('todo')
        }
    }
    return styles
}

const getButtonsState = (indx, length) => {
    if (indx > 0 && indx < length - 1) {
        return {
            showPreviousBtn: true,
            showNextBtn: true
        }
    } else if (indx === 0) {
        return {
            showPreviousBtn: false,
            showNextBtn: true
        }
    } else {
        return {
            showPreviousBtn: true,
            showNextBtn: false
        }
    }
}


const defaultFormData = {
    // Business Info
    businessName: '',
    businessType: 'Sol Proprietorship',
    annualRevenue: '',
    fullTimeEmployees: '',
    businessIndustry: 'Professional and Technical Services',
    businessSubIndustry: 'Advertising Agencies and all other related services',
    businessAddress1: '',
    businessAddress2: '',
    businessPhone: '',

    // Personal Info
    firstName: '',
    lastName: '',
    fullName: '', // Keep if required by the account section
    dob: '',
    ssn: '',
    ssnLast4: '',
    taxId: '',
    citizenship: 'Yes',
    mobilePhone: '',
    homePhone: '',
    phoneType: 'Business',
    phone: '',
    email: '',
    address: '',
    homeAddress1: '',
    homeAddress2: '',
    city: '',
    state: 'NY',
    zip: '',

    // Account Section
    accountType: '',
    cityStateZip: '',
    idType: '',
    idNumber: '',
    issuingAuthority: '',
    issueDate: '',
    expiryDate: '',

    // Nominee
    nomineeName: '',
    nomineeRelationship: '',
    nomineePhone: '',

    // Deposit
    depositAmount: '',
    paymentMode: '',

    // Agreement
    reference: '',
    agree: false,
    agreeDisclosure: false,
    agreeTerms: false,

    // Declaration
    signature: '',
    declarationDate: ''
}; // full structure


const Content = () => {
    const [formData, setFormData] = useState(defaultFormData);
    const [compState, setComp] = useState(0)

    const next = (currentStepIndex) => {
        if (!validateStep(currentStepIndex + 1)) {
            alert("Please complete all required fields before continuing.");
            return;
        }

        if (currentStepIndex === steps.length - 2) {
            // last step before submit
            if (!(formData?.firstName && formData?.lastName && formData?.email)) {
                alert("Please fill in First Name, Last Name and Email before submitting.");
                return;
            }


        }

        setStepState(currentStepIndex + 1);
    };

    const previous = () => setStepState(compState > 0 ? compState - 1 : compState)


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    useEffect(() => {
        setFormData({
            ...formData,
            fullName: `${formData.firstName || ''} ${formData.lastName || ''}`
        })
    }, [
        formData.firstName,
        formData.lastName
    ])

    const validateStep = (currentStep) => {
        switch (currentStep) {
            case 1:
                return !!formData.accountType && !!formData.email;
            case 2:
                return !!formData.fullName && !!formData.dob && !!formData.ssnLast4 &&
                    !!formData.address && !!formData.cityStateZip && !!formData.phone;
            case 3:
                return !!formData.idType && !!formData.idNumber && !!formData.issuingAuthority &&
                    !!formData.issueDate && !!formData.expiryDate;
            case 4:
                return !!formData.nomineeName && !!formData.nomineeRelationship &&
                    !!formData.nomineePhone && !!formData.depositAmount && !!formData.paymentMode;
            case 5:
                return !!formData.signature && !!formData.declarationDate;
            default:
                return true;
        }
    };


    const steps = [
        {
            component: <>
                <h4>SECTION 1: Account Type</h4>
                <label>Email</label>
                <input name="email" type="email" placeholder="Email" className="form-control" value={formData.email} onChange={handleChange} style={{ marginBottom: 10 }} />

                <label>Account Type</label>
                <select
                    name="accountType"
                    className="form-control"
                    onChange={handleChange}
                    value={formData.accountType}
                >
                    <option value="">-- Select --</option>
                    <option value="Fixed Deposit Account 3-year CD">
                        Fixed Deposit Account 3-year CD
                    </option>
                </select>
                <p>Membership Fee: $5</p>
            </>, text: "Basic Info", name: 'stepOne'
        },
        {
            component: <>
                <h4>SECTION 2: Personal Information</h4>

                <label>First Name</label>
                <input
                    name="firstName"
                    placeholder="First Name"
                    className="form-control mb-2"
                    value={formData.firstName}
                    onChange={handleChange}
                />

                <label>Last Name</label>
                <input
                    name="lastName"
                    placeholder="Last Name"
                    className="form-control mb-2"
                    value={formData.lastName}
                    onChange={handleChange}
                />

                {/* <label>Full Name</label>
                <input
                    name="fullName"
                    placeholder="Full Name"
                    className="form-control mb-2"
                    value={formData.fullName}
                    onChange={handleChange}
                /> */}

                <label>Date of Birth</label>
                <input
                    name="dob"
                    type="date"
                    placeholder="Date of Birth"
                    className="form-control mb-2"
                    value={formData.dob}
                    onChange={handleChange}
                />

                <label>Last 4 of Social</label>
                <input
                    name="ssnLast4"
                    placeholder="Last 4 of Social"
                    className="form-control mb-2"
                    value={formData.ssnLast4}
                    onChange={handleChange}
                />

                <label>Address</label>
                <input
                    name="address"
                    placeholder="Address"
                    className="form-control mb-2"
                    value={formData.address}
                    onChange={handleChange}
                />

                <label>City, State, Zip</label>
                <input
                    name="cityStateZip"
                    placeholder="City, State, Zip"
                    className="form-control mb-2"
                    value={formData.cityStateZip}
                    onChange={handleChange}
                />

                <label>Phone Number</label>
                <input
                    name="phone"
                    placeholder="Phone Number"
                    className="form-control mb-2"
                    value={formData.phone}
                    onChange={handleChange}
                />
            </>, text: "Personal Info", name: 'stepTwo'
        },

        {
            component: <>
                <h4>SECTION 3: Identification Details</h4>

                <label>ID Type</label>
                <select name="idType" className="form-control mb-2" value={formData.idType} onChange={handleChange}>
                    <option value="">-- Select --</option>
                    <option value="Driver’s License">Driver’s License</option>
                    <option value="Passport">Passport</option>
                    <option value="State ID">State ID</option>
                    <option value="Other">Other</option>
                </select>

                <label>ID Number</label>
                <input name="idNumber" placeholder="ID Number" className="form-control mb-2" value={formData.idNumber} onChange={handleChange} />

                <label>Issuing Authority</label>
                <input name="issuingAuthority" placeholder="Issuing Authority" className="form-control mb-2" value={formData.issuingAuthority} onChange={handleChange} />

                <label>Issue Date</label>
                <input name="issueDate" type="date" placeholder="Issue Date" className="form-control mb-2" value={formData.issueDate} onChange={handleChange} />

                <label>Expiry Date</label>
                <input name="expiryDate" type="date" placeholder="Expiry Date" className="form-control" value={formData.expiryDate} onChange={handleChange} />
            </>, text: "Business Location", name: 'stepThree'
        },
        {
            component: <>
                <h4>SECTION 4: Nominee Details</h4>

                <label>Nominee Name</label>
                <input name="nomineeName" placeholder="Nominee Name" className="form-control mb-2" value={formData.nomineeName} onChange={handleChange} />

                <label>Relationship</label>
                <input name="nomineeRelationship" placeholder="Relationship" className="form-control mb-2" value={formData.nomineeRelationship} onChange={handleChange} />

                <label>Phone Number</label>
                <input name="nomineePhone" placeholder="Phone Number" className="form-control mb-2" value={formData.nomineePhone} onChange={handleChange} />

                <h4>SECTION 5: Initial Deposit</h4>
                <p><strong>Send funds to:</strong></p>
                <p>
                    Zelle: 832-353-6109<br />
                    Chase Bank - Account: 939051733<br />
                    Routing Number: 111000614<br />
                    Memo: HHFCU
                </p>

                <label>Deposit Amount ($)</label>
                <input name="depositAmount" placeholder="Deposit Amount ($)" className="form-control mb-2" value={formData.depositAmount} onChange={handleChange} />

                <label>Mode of Payment</label>
                <select name="paymentMode" className="form-control" value={formData.paymentMode} onChange={handleChange}>
                    <option value="">-- Select --</option>
                    <option value="Cash">Cash</option>
                    <option value="Check">Check</option>
                    <option value="Bank Transfer">Bank Transfer</option>
                </select>
            </>, text: "Business Details", name: 'stepFour'
        },
        {
            component: <>
                <h4>SECTION 6: Declaration</h4>
                <p>
                    I hereby confirm the information provided above is true. I agree to abide by the terms and conditions of the Heritage Hub Federal Credit Union.
                </p>

                <label>Signature</label>
                <input name="signature" placeholder="Signature" className="form-control mb-2" value={formData.signature} onChange={handleChange} />

                <label>Date</label>
                <input name="declarationDate" type="date" placeholder="Date" className="form-control" value={formData.declarationDate} onChange={handleChange} />
            </>, text: "Verify Identity", name: 'stepFive'
        }
    ];


    const [step, setStep] = useState(1);
    const [stylesState, setStyles] = useState(getTopNavStyles(0, steps.length))
    const [buttonsState, setButtons] = useState(getButtonsState(0, steps.length))

    const setStepState = (indx) => {
        setStyles(getTopNavStyles(indx, steps.length))
        setComp(indx < steps.length ? indx : compState)
        setButtons(getButtonsState(indx, steps.length))
    }



    const { appState, setAppState } = useContext(AppContext);
    const [editItem, setEditItem] = useState({});
    const [loading, setLoading] = useState(false);
    const {
        section = false,
        modalOpen = false,
        editSection = "",
        editItemMain = {},
        siteName,
        header = {}
        // #ea6645
    } = appState;
    const {
        emails = 'modupe@varetechnologies.com,dipoty0@gmail.com,info@heritagehubfederal.org'
    } = header



    const handleStepChange = (currentStep) => {
        // You can log or update state if needed here
        console.log("Current step is:", currentStep);
    };




    useEffect(() => {
        // console.log('prevStyle', appState?.stepOne)

        if (appState?.editMode && appState?.stepOne) {
            setAppState((existing) => {
                return {
                    ...existing,
                    editItemMain: appState?.stepOne,
                    editSection: 'stepOne',
                    section: 'stepOne',
                    // modalOpen: false,
                    // editMode: true

                };
            });
        }


    }, [
        appState?.stepOne,
        appState?.editMode
    ])


    return (
        <section className="section-padding-bottom user-info-details">
            {appState?.editMode && appState?.stepOne
                ?
                <div>
                    <div style={{
                        justifyContent: 'center',
                        gap: 10,
                        display: 'flex',
                        flexDirection: 'row'
                    }}>
                        {steps?.map((res, i) => <div style={{
                            color: section == res?.name
                                ? 'red'
                                : ''
                        }}
                            onClick={() => {
                                if (appState?.[res?.name]) {
                                    setAppState((existing) => {
                                        return {
                                            ...existing,
                                            editItemMain: appState?.[res?.name],
                                            section: res?.name,
                                            editSection: res?.name,
                                            // editMode: true

                                        };
                                    });
                                }
                                else {
                                    setAppState((existing) => {
                                        return {
                                            ...existing,
                                            editItemMain: {},
                                            section: '',
                                            modalOpen: false,
                                            editMode: false,
                                        };
                                    });
                                }

                            }}>
                            {res?.name}
                        </div>)}
                    </div>
                </div>
                :
                <div className="container">
                    <div className="row">
                        <div className="offset-lg-3 col-lg-6">
                            <div className="user-info-tabs">
                                <div id="add-user-tab" className="step-app">
                                    <MultiStep
                                        steps={steps}
                                        next={next}
                                        previous={previous}
                                        compState={compState}
                                        setComp={setComp}
                                        stylesState={stylesState}
                                        setStyles={setStyles}
                                        buttonsState={buttonsState}
                                        setButtons={setButtons}
                                        setStepState={setStepState}

                                        handleClose={async () => {
                                            if (!(
                                                formData?.firstName &&
                                                formData?.lastName &&
                                                formData?.email
                                            )) {
                                                return
                                            }
                                            emails?.length > 0 &&
                                                await sendEmail(emailBankingApplicationForm({
                                                    ...formData,
                                                    emails,
                                                })).then(() => {
                                                    setFormData(defaultFormData);
                                                });
                                            await saveDataDB({
                                                query: {
                                                    date: moment(),
                                                    ...formData,
                                                    emails,
                                                    siteName: siteName,
                                                },
                                                keys: ["email"],
                                                resource: "vare_banking_application",
                                            }).then(res => {
                                                setFormData({})
                                                setTimeout(() => {
                                                    window.open('/', '_self')
                                                }, 1000)
                                            })

                                        }}
                                        prevStyle={prevStyle}
                                        nextStyle={nextStyle}
                                        onStepChange={handleStepChange} // optional: depends on MultiStep API
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>}
        </section>
    );
};

export default Content;






